import React, { useState } from 'react';
import { TIPOS_DOCUMENTO, subirDocumento } from '../../services/documentoService';
import './SubirDocumento.css';

const SubirDocumento = ({ casoId, onDocumentoSubido, onCancel }) => {
  const [file, setFile] = useState(null);
  const [tipo, setTipo] = useState(TIPOS_DOCUMENTO.CONTRATO);
  const [descripcion, setDescripcion] = useState('');
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState('');
  const [progreso, setProgreso] = useState(0);

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    console.log('Archivo seleccionado:', selectedFile?.name);
    
    if (selectedFile) {
      if (selectedFile.size > 1 * 1024 * 1024) {
        setError('El archivo no puede ser mayor a 1MB (Firestore)');
        setFile(null);
        return;
      }
    
      const tiposPermitidos = ['application/pdf', 'image/jpeg', 'image/jpg', 'image/png'];
      if (!tiposPermitidos.includes(selectedFile.type)) {
        setError('Solo se permiten archivos PDF, JPG o PNG');
        setFile(null);
        return;
      }
      
      setFile(selectedFile);
      setError('');
      console.log('Archivo válido:', selectedFile.name, (selectedFile.size / 1024).toFixed(2), 'KB');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!file) {
      setError('Debe seleccionar un archivo');
      return;
    }

    if (!casoId) {
      setError('ID del caso no válido');
      return;
    }

    try {
      setUploading(true);
      setError('');
      setProgreso(10);
      
    
      const interval = setInterval(() => {
        setProgreso(prev => {
          if (prev >= 90) {
            clearInterval(interval);
            return 90;
          }
          return prev + 10;
        });
      }, 500);
      
      console.log('Subiendo documento...');
      const resultado = await subirDocumento(casoId, file, tipo, descripcion);
      
      clearInterval(interval);
      setProgreso(100);
      console.log('Subida exitosa:', resultado);
      
      setTimeout(() => {
        onDocumentoSubido(resultado);
      }, 500);
      
    } catch (error) {
      console.error('Error:', error);
      setError('Error: ' + error.message);
      setProgreso(0);
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="subir-documento">
      <h3>Subir Nuevo Documento</h3>
      <p className="info-text">Máximo 1MB. Formatos: PDF, JPG, PNG</p>
      
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label>Tipo de Documento</label>
          <select 
            value={tipo} 
            onChange={(e) => setTipo(e.target.value)}
            disabled={uploading}
          >
            <option value={TIPOS_DOCUMENTO.CONTRATO}>Contrato de Compraventa</option>
            <option value={TIPOS_DOCUMENTO.IMPRONTA}>Improntas</option>
            <option value={TIPOS_DOCUMENTO.FORMULARIO_TRASPASO}>Formulario de Traspaso</option>
            <option value={TIPOS_DOCUMENTO.INFORME_CESVI}>Informe Cesvi Colombia</option>
            <option value={TIPOS_DOCUMENTO.SOAT}>SOAT</option>
            <option value={TIPOS_DOCUMENTO.TARJETA_PROPIEDAD}>Tarjeta de Propiedad</option>
            <option value={TIPOS_DOCUMENTO.OTRO}>Otro</option>
          </select>
        </div>

        <div className="form-group">
          <label>Archivo (PDF, JPG, PNG - Máx 1MB)</label>
          <input
            type="file"
            onChange={handleFileChange}
            accept=".pdf,.jpg,.jpeg,.png"
            className="file-input"
            disabled={uploading}
          />
          {file && (
            <div className="file-info">
              <span>{file.name}</span>
              <span>{(file.size / 1024).toFixed(2)} KB</span>
            </div>
          )}
        </div>

        <div className="form-group">
          <label>Descripción (opcional)</label>
          <textarea
            value={descripcion}
            onChange={(e) => setDescripcion(e.target.value)}
            rows="2"
            placeholder="Agregar una descripción del documento..."
            disabled={uploading}
          />
        </div>

        {uploading && (
          <div className="upload-progress">
            <div className="progress-bar">
              <div className="progress-fill" style={{ width: `${progreso}%` }} />
            </div>
            <p>Procesando archivo... {progreso}%</p>
          </div>
        )}

        {error && (
          <div className="error-message">
            <strong>Error:</strong> {error}
          </div>
        )}

        <div className="form-actions">
          <button type="button" className="btn-secondary" onClick={onCancel} disabled={uploading}>
            Cancelar
          </button>
          <button type="submit" className="btn-primary" disabled={uploading || !file}>
            {uploading ? 'Subiendo...' : 'Subir Documento'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default SubirDocumento;